import { cn } from '../lib/cn';

interface OnlineDotProps {
  online: boolean;
  className?: string;
}

export function OnlineDot({ online, className }: OnlineDotProps) {
  if (!online) return null;
  return (
    <span
      className={cn('inline-block h-2 w-2 bg-green-500 rounded-full', className)}
      title="Онлайн сейчас"
    />
  );
}
